function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire984b"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire984b"] = parcelRequire;
}
parcelRequire.register("kyEFX", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $ef7689007096c8a0$export$6503ec6e8aabbaf; }, function (v) { return $ef7689007096c8a0$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $ef7689007096c8a0$export$f7ad0328861e2f03; }, function (v) { return $ef7689007096c8a0$export$f7ad0328861e2f03 = v; });
var $ef7689007096c8a0$export$6503ec6e8aabbaf;
var $ef7689007096c8a0$export$f7ad0328861e2f03;
"use strict";
var $ef7689007096c8a0$var$mapping = {};
function $ef7689007096c8a0$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$ef7689007096c8a0$var$mapping[keys[i]] = pairs[keys[i]];
}
function $ef7689007096c8a0$var$resolve(id) {
    var resolved = $ef7689007096c8a0$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$ef7689007096c8a0$export$6503ec6e8aabbaf = $ef7689007096c8a0$var$register;
$ef7689007096c8a0$export$f7ad0328861e2f03 = $ef7689007096c8a0$var$resolve;

});

var $d673aa3e523be36b$exports = {};

(parcelRequire("kyEFX")).register(JSON.parse('{"hnH0c":"wheeladmin.abad5f82.js","1JpBc":"F.6b6d9f7c.png","5JpFe":"H.861eac15.png","4oBZe":"C.4155e805.png","ayPmu":"FH.1175a7c9.png","lfU0b":"CF.0bf185a5.png","4YbjV":"CH.e5516591.png","5TEX7":"CFH.41dd1b2b.png","aoEst":"check-wheel.d7d33cc6.svg","eLldS":"x-wheel.7f1336c5.svg","j6GAN":"youshouldnotbehere.f0aefe0e.js"}'));


var $4zpiX = parcelRequire("4zpiX");
const $367e9b185e9370bd$var$SERVER_URL = "https://funsizeapps.b4a.app/";
const $367e9b185e9370bd$var$APP_ID = "rHwkgreMFdjMqUGu9EoemDE4YMomVNLQwIX9Czr9";
const $367e9b185e9370bd$var$JAVASCRIPT_KEY = "xdllsMsa2dAhWFuovVzyJTj7OIZmzLMeo5vsEFYv";
$4zpiX.initialize($367e9b185e9370bd$var$APP_ID, $367e9b185e9370bd$var$JAVASCRIPT_KEY);
$4zpiX.serverURL = $367e9b185e9370bd$var$SERVER_URL;
var $367e9b185e9370bd$var$funsizer, $367e9b185e9370bd$var$currentDataSource, $367e9b185e9370bd$var$currentDataEdit, $367e9b185e9370bd$var$btnNewS, $367e9b185e9370bd$var$attributes, $367e9b185e9370bd$var$cats, $367e9b185e9370bd$var$sets, $367e9b185e9370bd$var$spotModal, $367e9b185e9370bd$var$btnSave, $367e9b185e9370bd$var$btnCancel, $367e9b185e9370bd$var$adminTable, $367e9b185e9370bd$var$btnDel, $367e9b185e9370bd$var$delModal, $367e9b185e9370bd$var$testModal;
var $367e9b185e9370bd$var$isEditing = false;
var $63088cb229aafa75$exports = {};

$63088cb229aafa75$exports = new URL((parcelRequire("kyEFX")).resolve("1JpBc"), import.meta.url).toString();


var $0d49cce2ff8d5d0c$exports = {};

$0d49cce2ff8d5d0c$exports = new URL((parcelRequire("kyEFX")).resolve("5JpFe"), import.meta.url).toString();


var $f90a7ab16f210d98$exports = {};

$f90a7ab16f210d98$exports = new URL((parcelRequire("kyEFX")).resolve("4oBZe"), import.meta.url).toString();


var $55356a7496f24501$exports = {};

$55356a7496f24501$exports = new URL((parcelRequire("kyEFX")).resolve("ayPmu"), import.meta.url).toString();


var $4a3f0322b8dfd60c$exports = {};

$4a3f0322b8dfd60c$exports = new URL((parcelRequire("kyEFX")).resolve("lfU0b"), import.meta.url).toString();


var $632cd5b9717d5dc7$exports = {};

$632cd5b9717d5dc7$exports = new URL((parcelRequire("kyEFX")).resolve("4YbjV"), import.meta.url).toString();


var $489cbe7c4c5ae28f$exports = {};

$489cbe7c4c5ae28f$exports = new URL((parcelRequire("kyEFX")).resolve("5TEX7"), import.meta.url).toString();


const $367e9b185e9370bd$var$defaultImages = [
    new URL($63088cb229aafa75$exports),
    new URL($0d49cce2ff8d5d0c$exports),
    new URL($f90a7ab16f210d98$exports),
    new URL($55356a7496f24501$exports),
    new URL($4a3f0322b8dfd60c$exports),
    new URL($632cd5b9717d5dc7$exports),
    new URL($489cbe7c4c5ae28f$exports)
];
window.addEventListener("load", ()=>{
    $367e9b185e9370bd$var$setUIState(false);
    $367e9b185e9370bd$var$btnNewS = document.getElementById("btn_new_spot");
    $367e9b185e9370bd$var$btnNewS.addEventListener("click", $367e9b185e9370bd$var$newSpot);
    $367e9b185e9370bd$var$spotModal = document.getElementById("modal_spot");
    $367e9b185e9370bd$var$btnCancel = document.getElementById("btn_cancel");
    $367e9b185e9370bd$var$btnSave = document.getElementById("btn_save");
    $367e9b185e9370bd$var$adminTable = document.getElementById("admin-table");
    $367e9b185e9370bd$var$btnCancel.onclick = $367e9b185e9370bd$var$cancelSpot;
    $367e9b185e9370bd$var$btnSave.onclick = $367e9b185e9370bd$var$saveSpot;
    document.getElementById("input_file").addEventListener("change", (e)=>{
        document.getElementById("spot-image").src = URL.createObjectURL(e.target.files[0]);
    });
    $367e9b185e9370bd$var$delModal = document.getElementById("modal_delete");
    $367e9b185e9370bd$var$btnDel = document.getElementById("btn_delete");
    $367e9b185e9370bd$var$btnDel.addEventListener("click", ()=>{
        $367e9b185e9370bd$var$delModal.classList.remove("hidden");
    });
    document.getElementById("btn_nm").addEventListener("click", ()=>{
        $367e9b185e9370bd$var$delModal.classList.add("hidden");
    });
    document.getElementById("btn_delete_confirm").addEventListener("click", ()=>{
        $367e9b185e9370bd$var$setUIState(false);
        $367e9b185e9370bd$var$currentDataEdit.destroy().then((r)=>{
            $367e9b185e9370bd$var$currentDataSource = $367e9b185e9370bd$var$currentDataSource.filter((p)=>p.id != $367e9b185e9370bd$var$currentDataEdit.id);
            $367e9b185e9370bd$var$currentDataEdit = null;
            $367e9b185e9370bd$var$setUIState(true);
            $367e9b185e9370bd$var$resetSpotUI();
            $367e9b185e9370bd$var$renderSpots();
            $367e9b185e9370bd$var$delModal.classList.add("hidden");
            $367e9b185e9370bd$var$cancelSpot();
        }, (error)=>{
            $367e9b185e9370bd$var$setUIState(true);
            alert("Failed deleting object: " + error);
            $367e9b185e9370bd$var$delModal.classList.add("hidden");
        });
    });
    $367e9b185e9370bd$var$testModal = document.getElementById("testModal");
    document.getElementById("spot_preview").addEventListener("click", ()=>{
        $367e9b185e9370bd$var$togglePreview();
    });
    document.getElementById("btn_tryAgain").addEventListener("click", ()=>{
        $367e9b185e9370bd$var$togglePreview();
    });
    $367e9b185e9370bd$var$initFunsizer();
});
const $367e9b185e9370bd$var$initFunsizer = ()=>{
    $367e9b185e9370bd$var$funsizer = $4zpiX.User.current();
    if ($367e9b185e9370bd$var$funsizer) {
        $367e9b185e9370bd$var$setUIState(true);
        $367e9b185e9370bd$var$getAttributes().then(()=>{
            $367e9b185e9370bd$var$getSpots().then(()=>{
                $367e9b185e9370bd$var$renderSpots();
            }).catch(function(e) {
                $367e9b185e9370bd$var$handleParseError("Error when fetching Spots", e);
            });
        }).catch(function(e) {
            $367e9b185e9370bd$var$handleParseError("Error when fetching Attributes", e);
        });
    } else window.location = `${window.location.origin}/${window.location.pathname.includes("staging") ? "staging/" : ""}login.html?redirect=${window.location.pathname}`;
};
const $367e9b185e9370bd$var$setUIState = (enabled)=>{
    if (enabled) {
        gsap.to(document.getElementsByClassName("loader-container")[0], {
            opacity: 0,
            duration: 0.25
        });
        document.body.style.pointerEvents = "true";
    } else {
        gsap.to(document.getElementsByClassName("loader-container")[0], {
            opacity: 1,
            duration: 0.25
        });
        gsap.to(document.getElementsByClassName("loader")[0], {
            scale: 0.5,
            duration: 1,
            ease: "bounce.out",
            repeat: -1,
            yoyo: true
        });
        document.body.style.pointerEvents = "false";
    }
};
const $367e9b185e9370bd$var$togglePreview = ()=>{
    if ($367e9b185e9370bd$var$testModal.classList.contains("hidden")) {
        $367e9b185e9370bd$var$testModal.classList.remove("hidden");
        gsap.fromTo($367e9b185e9370bd$var$testModal, {
            x: window.innerWidth
        }, {
            x: 0,
            duration: 0.5,
            ease: "expo.out(1, 0.5)"
        });
        document.getElementById("winner_name").innerHTML = document.getElementById("name").value;
        const item = document.getElementById("winner_img");
        item.src = document.getElementById("spot-image").src;
        document.querySelector(".quote-wrapper").classList.remove("hidden");
        document.getElementById("winner_quote").innerHTML = document.getElementById("quote").value.length > 0 ? `"${document.getElementById("quote").value.replace(new RegExp('"', "g"), "")}"` : "";
        document.getElementById("winner_quotee").innerHTML = document.getElementById("quotee").value;
        document.getElementById("winner_address").innerHTML = document.getElementById("address").value;
        document.getElementById("winner_address").href = document.getElementById("map-link").value;
        const menu = document.getElementById("winner_menu");
        menu.classList.remove("hidden");
        menu.innerHTML = document.getElementById("website").value.replace("https://www.", "").replace(".com/", ".com");
    } else $367e9b185e9370bd$var$testModal.classList.add("hidden");
};
const $367e9b185e9370bd$var$updateDefaultImage = ()=>{
    if ($367e9b185e9370bd$var$currentDataEdit && $367e9b185e9370bd$var$currentDataEdit.get("Image")) return;
    const fInput = document.getElementById("input_file");
    if (fInput.files.length > 0) return;
    const opts = document.getElementById("category").options;
    var input = document.getElementById("spot-image");
    if (opts[0].selected && opts[1].selected && opts[2].selected) input.src = $367e9b185e9370bd$var$defaultImages[6];
    else if (opts[0].selected && opts[1].selected) input.src = $367e9b185e9370bd$var$defaultImages[3];
    else if (opts[0].selected && opts[2].selected) input.src = $367e9b185e9370bd$var$defaultImages[4];
    else if (opts[1].selected && opts[2].selected) input.src = $367e9b185e9370bd$var$defaultImages[5];
    else if (opts[1].selected) input.src = $367e9b185e9370bd$var$defaultImages[1];
    else if (opts[0].selected) input.src = $367e9b185e9370bd$var$defaultImages[0];
    else input.src = $367e9b185e9370bd$var$defaultImages[2];
};
async function $367e9b185e9370bd$var$getAttributes() {
    const query = new $4zpiX.Query("WheelSpotAttribute");
    try {
        $367e9b185e9370bd$var$attributes = await query.find();
        var input = document.getElementById("category");
        const categories = $367e9b185e9370bd$var$attributes.filter((a)=>a.get("Type") == "Category");
        categories.forEach((c)=>{
            const o = document.createElement("option");
            o.text = c.get("Value");
            o.value = c.id;
            input.add(o);
        });
        [
            ...input.options
        ].forEach(function(element) {
            element.addEventListener("mousedown", function(e) {
                e.preventDefault();
                element.parentElement.focus();
                this.selected = !this.selected;
                $367e9b185e9370bd$var$updateDefaultImage();
                return false;
            }, false);
        });
        input = document.getElementById("setting");
        const settings = $367e9b185e9370bd$var$attributes.filter((a)=>a.get("Type") == "Setting");
        settings.forEach((c)=>{
            const o = document.createElement("option");
            o.text = c.get("Value");
            o.value = c.id;
            input.add(o);
        });
        [
            ...input.options
        ].forEach(function(element) {
            element.addEventListener("mousedown", function(e) {
                e.preventDefault();
                element.parentElement.focus();
                this.selected = !this.selected;
                return false;
            }, false);
        });
    } catch (error) {
        throw error;
    }
}
/**
 * Spot Calls
 */ async function $367e9b185e9370bd$var$getSpots() {
    const query = new $4zpiX.Query("WheelSpot");
    query.ascending("Name");
    try {
        $367e9b185e9370bd$var$currentDataSource = await query.find();
    } catch (error) {
        throw error;
    }
}
var $dfec48e43b5f4164$exports = {};

$dfec48e43b5f4164$exports = new URL((parcelRequire("kyEFX")).resolve("aoEst"), import.meta.url).toString();


var $ddd7e2d5f941b1b9$exports = {};

$ddd7e2d5f941b1b9$exports = new URL((parcelRequire("kyEFX")).resolve("eLldS"), import.meta.url).toString();




const $367e9b185e9370bd$var$renderSpots = ()=>{
    const spots = document.getElementById("admin_data");
    spots.innerHTML = "";
    for(var i = 0; i < $367e9b185e9370bd$var$currentDataSource.length; i++){
        const spot = $367e9b185e9370bd$var$currentDataSource[i];
        const row = document.createElement("div");
        const cellName = document.createElement("div");
        const cellCategory = document.createElement("div");
        const cellHasSnacks = document.createElement("div");
        const cellSetting = document.createElement("div");
        const cellParty = document.createElement("div");
        const cellAddy = document.createElement("div");
        const cellSite = document.createElement("div");
        const cellSaid = document.createElement("div");
        const cellSayer = document.createElement("div");
        const cellHasSnacksIcon = document.createElement("img");
        const cellPartyIcon = document.createElement("img");
        const cellSiteAnchor = document.createElement("a");
        row.classList.add("table-row");
        cellName.classList.add("cell-name");
        cellCategory.classList.add("cell-category");
        cellHasSnacks.classList.add("cell-large-party");
        cellSetting.classList.add("cell-setting");
        cellParty.classList.add("cell-large-party");
        cellAddy.classList.add("cell-address");
        cellSite.classList.add("cell-website");
        cellSaid.classList.add("cell-quote");
        cellSayer.classList.add("cell-said-by");
        spots.append(row);
        row.append(cellName, cellCategory, cellHasSnacks, cellSetting, cellParty, cellAddy, cellSite, cellSaid, cellSayer);
        cellParty.append(cellPartyIcon);
        cellHasSnacks.append(cellHasSnacksIcon);
        cellSite.append(cellSiteAnchor);
        cellName.innerHTML = spot.get("Name");
        var values = $367e9b185e9370bd$var$attributes.filter((a)=>spot.get("Category").includes(a.id));
        values.forEach((v)=>{
            const catTag = document.createElement("div");
            catTag.classList.add("tag");
            catTag.innerHTML = v.get("Value");
            if (v.get("Value") === "Happy Hour") catTag.classList.add("happy-hour");
            else if (v.get("Value") === "Coffee") catTag.classList.add("coffee");
            cellCategory.append(catTag);
        });
        let iconURL;
        if (spot.get("HasSnacks") == true) iconURL = new URL($dfec48e43b5f4164$exports);
        else iconURL = new URL($ddd7e2d5f941b1b9$exports);
        cellHasSnacksIcon.src = iconURL;
        values = $367e9b185e9370bd$var$attributes.filter((a)=>spot.get("Setting").includes(a.id));
        values.forEach((v)=>{
            const setSpan = document.createElement("span");
            setSpan.innerHTML = v.get("Value");
            cellSetting.append(setSpan);
        });
        if (spot.get("LargeParties") == true) iconURL = new URL($dfec48e43b5f4164$exports);
        else iconURL = new URL($ddd7e2d5f941b1b9$exports);
        cellPartyIcon.src = iconURL;
        if (spot.get("Address").indexOf(", Austin") > -1) cellAddy.innerHTML = spot.get("Address").substring(0, spot.get("Address").indexOf(", Austin"));
        else cellAddy.innerHTML = spot.get("Address");
        cellSiteAnchor.href = spot.get("WebsiteUrl");
        cellSiteAnchor.setAttribute("target", "_blank");
        cellSiteAnchor.innerHTML = spot.get("WebsiteUrl");
        if (spot.get("Quote")) cellSaid.innerHTML = `"${spot.get("Quote").replace(new RegExp('"', "g"), "")}"`;
        if (spot.get("Quotee")) cellSayer.innerHTML = spot.get("Quotee");
        const clicker = document.createElement("div");
        clicker.classList.add("row");
        clicker.id = spot.id;
        clicker.addEventListener("click", $367e9b185e9370bd$var$editSpot);
        row.append(clicker);
    }
};
const $367e9b185e9370bd$var$editSpot = (e)=>{
    $367e9b185e9370bd$var$isEditing = true;
    $367e9b185e9370bd$var$btnDel.classList.remove("hidden");
    $367e9b185e9370bd$var$currentDataEdit = $367e9b185e9370bd$var$currentDataSource.filter((p)=>p.id == e.target.id)[0];
    if (!$367e9b185e9370bd$var$currentDataEdit) return;
    const fInput = document.getElementById("input_file");
    document.getElementById("form-title").innerHTML = "Edit spot";
    fInput.value = "";
    $367e9b185e9370bd$var$spotModal.classList.remove("hidden");
    $367e9b185e9370bd$var$adminTable.classList.add("hidden");
    var input = document.getElementById("name");
    input.value = $367e9b185e9370bd$var$currentDataEdit.get("Name");
    input = document.getElementById("category");
    [
        ...input.options
    ].forEach(function(element) {
        element.selected = $367e9b185e9370bd$var$currentDataEdit.get("Category").includes(element.value);
    });
    input = document.getElementById("setting");
    [
        ...input.options
    ].forEach(function(element) {
        element.selected = $367e9b185e9370bd$var$currentDataEdit.get("Setting").includes(element.value);
    });
    input = document.getElementById("large-group");
    input.selectedIndex = $367e9b185e9370bd$var$currentDataEdit.get("LargeParties") ? 0 : 1;
    input = document.getElementById("has-snacks");
    input.selectedIndex = $367e9b185e9370bd$var$currentDataEdit.get("HasSnacks") ? 0 : 1;
    var val = $367e9b185e9370bd$var$currentDataEdit.get("Quote");
    input = document.getElementById("quote");
    if (val) input.value = $367e9b185e9370bd$var$currentDataEdit.get("Quote");
    else input.value = "";
    var val = $367e9b185e9370bd$var$currentDataEdit.get("Quotee");
    input = document.getElementById("quotee");
    if (val) input.value = $367e9b185e9370bd$var$currentDataEdit.get("Quotee");
    else input.value = "";
    input = document.getElementById("address");
    input.value = $367e9b185e9370bd$var$currentDataEdit.get("Address");
    input = document.getElementById("map-link");
    input.value = $367e9b185e9370bd$var$currentDataEdit.get("MapUrl");
    input = document.getElementById("website");
    input.value = $367e9b185e9370bd$var$currentDataEdit.get("WebsiteUrl");
    val = $367e9b185e9370bd$var$currentDataEdit.get("Image");
    if (val) {
        input = document.getElementById("spot-image");
        input.src = val.url();
    } else $367e9b185e9370bd$var$updateDefaultImage();
};
const $367e9b185e9370bd$var$newSpot = ()=>{
    $367e9b185e9370bd$var$resetSpotUI();
    $367e9b185e9370bd$var$isEditing = false;
    $367e9b185e9370bd$var$btnDel.classList.add("hidden");
    document.getElementById("form-title").innerHTML = "Add spot";
    $367e9b185e9370bd$var$spotModal.classList.remove("hidden");
    $367e9b185e9370bd$var$adminTable.classList.add("hidden");
};
const $367e9b185e9370bd$var$saveSpot = (e)=>{
    e.stopPropagation();
    const fInput = document.getElementById("input_file");
    let parseFile;
    $367e9b185e9370bd$var$cats = [
        ...document.getElementById("category").options
    ].filter((o)=>o.selected);
    $367e9b185e9370bd$var$sets = [
        ...document.getElementById("setting").options
    ].filter((o)=>o.selected);
    if (document.getElementById("name").value.length < 1 || $367e9b185e9370bd$var$cats.length < 1 || $367e9b185e9370bd$var$sets.length < 1 || document.getElementById("address").value.length < 1 || document.getElementById("map-link").value.length < 1) {
        alert("\uD83E\uDD2C Yo, all values are required for a spot. \uD83E\uDD2C");
        return;
    }
    $367e9b185e9370bd$var$setUIState(false);
    if (fInput.files.length > 0) {
        const file = fInput.files[0];
        const name = fInput.files[0].name;
        parseFile = new $4zpiX.File(name, file);
    }
    if (parseFile) parseFile.save().then(()=>{
        $367e9b185e9370bd$var$saveSpotCore(parseFile);
    }, function(error) {
        window.alert("Error while saving image", error);
    });
    else $367e9b185e9370bd$var$saveSpotCore();
    $367e9b185e9370bd$var$spotModal.classList.add("hidden");
    $367e9b185e9370bd$var$adminTable.classList.remove("hidden");
};
const $367e9b185e9370bd$var$saveSpotCore = (i)=>{
    const WheelSpot = $4zpiX.Object.extend("WheelSpot");
    const wp = new WheelSpot();
    if ($367e9b185e9370bd$var$currentDataEdit) wp.set("objectId", $367e9b185e9370bd$var$currentDataEdit.id);
    wp.set("Name", document.getElementById("name").value);
    wp.set("Quote", document.getElementById("quote").value);
    wp.set("Quotee", document.getElementById("quotee").value);
    wp.set("Address", document.getElementById("address").value);
    wp.set("MapUrl", document.getElementById("map-link").value);
    wp.set("WebsiteUrl", document.getElementById("website").value);
    wp.set("HasSnacks", document.getElementById("has-snacks").selectedIndex == 0);
    wp.set("LargeParties", document.getElementById("large-group").selectedIndex == 0);
    var vals = $367e9b185e9370bd$var$cats.map((c)=>c.value);
    wp.set("Category", vals);
    var vals = $367e9b185e9370bd$var$sets.map((c)=>c.value);
    wp.set("Setting", vals);
    if (i) wp.set("Image", i);
    wp.save().then((r)=>{
        $367e9b185e9370bd$var$setUIState(true);
        if ($367e9b185e9370bd$var$isEditing) $367e9b185e9370bd$var$isEditing = false;
        else $367e9b185e9370bd$var$currentDataSource.push(r);
        $367e9b185e9370bd$var$resetSpotUI();
        $367e9b185e9370bd$var$renderSpots();
    }, (error)=>{
        $367e9b185e9370bd$var$setUIState(true);
        alert("Failed saving object: " + error);
    });
};
const $367e9b185e9370bd$var$cancelSpot = (e)=>{
    if (e) e.stopPropagation();
    $367e9b185e9370bd$var$isEditing = false;
    $367e9b185e9370bd$var$spotModal.classList.add("hidden");
    $367e9b185e9370bd$var$adminTable.classList.remove("hidden");
};
const $367e9b185e9370bd$var$resetSpotUI = ()=>{
    $367e9b185e9370bd$var$currentDataEdit = null;
    var input = document.getElementById("name");
    input.value = "";
    input = document.getElementById("category");
    for(var i = 0; i < input.options.length; i++)input.options[i].selected = i == 0;
    input = document.getElementById("setting");
    for(var i = 0; i < input.options.length; i++)input.options[i].selected = i == 0;
    input = document.getElementById("large-group");
    input.selectedIndex = 1;
    input = document.getElementById("has-snacks");
    input.selectedIndex = 1;
    input = document.getElementById("quote");
    input.value = "";
    input = document.getElementById("address");
    input.value = "";
    input = document.getElementById("map-link");
    input.value = "";
    input = document.getElementById("website");
    input.value = "";
    input = document.getElementById("spot-image");
    input.src = $367e9b185e9370bd$var$defaultImages[0];
};
function $367e9b185e9370bd$var$handleParseError(msg, err) {
    switch(err.code){
        case $4zpiX.Error.INVALID_SESSION_TOKEN:
            $4zpiX.User.logOut();
            window.location = `${window.location.origin}/${window.location.pathname.includes("staging") ? "staging/" : ""}login.html?redirect=${window.location.pathname}`;
            break;
        default:
            console.log(`${msg} : ${err.code} - ${err.message}`);
    }
}


//# sourceMappingURL=wheeladmin.abad5f82.js.map
